import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const arrowRampRight: ISVGPersonalProps = {
  viewBox: '0 0 24 24',
  content: (
    <g>
      <path
        d="M18 7L20.913 9.91296V9.91296C20.961 9.96103 20.961 10.039 20.913 10.087V10.087L18 13"
        stroke="#B3B3B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 10H16.5C10.701 10 6 14.701 6 20.5V21"
        stroke="#B3B3B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
};
